// Catálogo de telas e rotas pesquisáveis do GSPro12 (SCORPIO)
// Permite busca instantânea, navegação direta e suporte a sinônimos / contexto

export const SYSTEM_ROUTES = [
  // COMERCIAL
  {
    name: "Contratos",
    path: "/contrato",
    category: "COMERCIAL",
    elIcon: "el-icon-document-copy",
    description: "Gestão de contratos, clientes, ficha técnica e serviços",
    keywords: ["contrato", "contratos", "comercial", "cliente", "ficha tecnica", "proposta", "renovacao"]
  },
  {
    name: "Contrato > Serviços",
    path: "/contrato",
    category: "COMERCIAL",
    elIcon: "el-icon-setting",
    description: "Aba de serviços de campo, aplicações e OSs do contrato",
    keywords: ["servico", "servicos", "os", "ordem de servico", "contrato", "aplicacao", "visitas"]
  },
  {
    name: "Kanban Comercial (Prospecção)",
    path: "/kanban",
    category: "COMERCIAL",
    elIcon: "el-icon-data-board",
    description: "Funil de vendas, propostas e prospecção de clientes",
    keywords: ["kanban", "prospeccao", "propostas", "comercial", "vendas", "leads", "funil"]
  },
  {
    name: "Kanban de Renovações",
    path: "/kanban-renovacao",
    category: "COMERCIAL",
    elIcon: "el-icon-refresh",
    description: "Contratos a vencer, renegociação e fluxo de renovações",
    keywords: ["renovacao", "renovacoes", "kanban", "vencimento", "contrato"]
  },
  {
    name: "Clientes",
    path: "/cliente",
    category: "COMERCIAL",
    elIcon: "el-icon-user",
    description: "Cadastro, busca e gestão de clientes e contatos",
    keywords: ["cliente", "clientes", "cadastro", "cnpj", "razao social", "contato", "telefone"]
  },
  {
    name: "Prospecção / Propostas",
    path: "/prospeccao",
    category: "COMERCIAL",
    elIcon: "el-icon-edit-outline",
    description: "Elaboração de propostas comerciais e orçamentos",
    keywords: ["proposta", "propostas", "orcamento", "prospeccao", "comercial"]
  },
  {
    name: "Documentos",
    path: "/documentos",
    category: "COMERCIAL",
    elIcon: "el-icon-folder-opened",
    description: "Documentos, arquivos anexos e fichas técnicas",
    keywords: ["documento", "documentos", "anexos", "arquivos", "comercial"]
  },
  {
    name: "Levantamentos (Associar)",
    path: "/lev-associar",
    category: "COMERCIAL",
    elIcon: "el-icon-search",
    description: "Associação e distribuição de vistorias técnicas",
    keywords: ["levantamento", "levantamentos", "vistoria", "associar"]
  },

  // PCO (PLANEJAMENTO E CONTROLE OPERACIONAL)
  {
    name: "Agenda OS",
    path: "/agenda-os",
    category: "PCO",
    elIcon: "el-icon-date",
    description: "Calendário operacional e agendamento de ordens de serviço",
    keywords: ["agenda", "agenda os", "calendario", "pco", "servicos", "horario", "agendamento"]
  },
  {
    name: "Associar OS / Rotas",
    path: "/os-associar",
    category: "PCO",
    elIcon: "el-icon-sort",
    description: "Distribuição diária de OSs para técnicos e veículos",
    keywords: ["associar", "associar os", "rotas", "tecnico", "distribuicao", "pco", "veiculo", "carro"]
  },
  {
    name: "Confirmação de OS",
    path: "/os-confirmacao",
    category: "PCO",
    elIcon: "el-icon-check",
    description: "Disparos WATI e confirmação de serviços com clientes",
    keywords: ["confirmacao", "confirmacao os", "wati", "whatsapp", "pco", "servico", "agendamento"]
  },
  {
    name: "Retornos de OS",
    path: "/retorno-os",
    category: "PCO",
    elIcon: "el-icon-back",
    description: "Laudos, retornos do app mobile e execução técnica",
    keywords: ["retorno", "retorno os", "executado", "laudo", "tecnico", "relatorio", "pco"]
  },
  {
    name: "Pós-Venda",
    path: "/pos-venda",
    category: "PCO",
    elIcon: "el-icon-phone-outline",
    description: "Comunicação pós-serviço e acompanhamento de satisfação",
    keywords: ["pos venda", "pos-venda", "wati", "satisfacao", "contato", "pco"]
  },
  {
    name: "Serviços por Endereço",
    path: "/servicos-endereco",
    category: "PCO",
    elIcon: "el-icon-location-information",
    description: "Histórico de serviços e aplicações por endereço do cliente",
    keywords: ["servicos endereco", "endereco", "historico", "os", "local", "pco"]
  },
  {
    name: "Rotas Operacionais",
    path: "/rota",
    category: "PCO",
    elIcon: "el-icon-map-location",
    description: "Cadastro de rotas, setores e zonas de atendimento",
    keywords: ["rota", "rotas", "setores", "bairros", "zonas", "pco"]
  },
  {
    name: "Configuração de Rotas",
    path: "/rota-config",
    category: "PCO",
    elIcon: "el-icon-set-up",
    description: "Vínculo de técnicos, veículos e turnos por rota",
    keywords: ["rota config", "rota-config", "tecnicos rota", "veiculos", "turnos"]
  },
  {
    name: "Avaliação Técnica",
    path: "/avaliacao-tecnica",
    category: "PCO",
    elIcon: "el-icon-medal",
    description: "Desempenho operacional e produção dos técnicos",
    keywords: ["avaliacao", "avaliacao tecnica", "produtividade", "tecnicos", "pco"]
  },
  {
    name: "Treinamentos",
    path: "/treinamento",
    category: "PCO",
    elIcon: "el-icon-reading",
    description: "Controle de capacitação e treinamentos da equipe",
    keywords: ["treinamento", "capacitacao", "curso", "operacional", "tecnicos"]
  },

  // FINANCEIRO
  {
    name: "Contas a Receber",
    path: "/contas-receber",
    category: "FINANCEIRO",
    elIcon: "el-icon-money",
    description: "Faturas, boletos, recebimentos e controle de inadimplência",
    keywords: ["contas a receber", "receber", "faturas", "financeiro", "boletos", "recebimentos"]
  },
  {
    name: "Cobrança WATI",
    path: "/cobranca",
    category: "FINANCEIRO",
    elIcon: "el-icon-chat-dot-round",
    description: "Envio de lembretes e cobranças em massa via WhatsApp",
    keywords: ["cobranca", "wati", "whatsapp", "inadimplencia", "disparo em massa", "financeiro"]
  },
  {
    name: "Para Faturar (Contratos Faturamento)",
    path: "/contratos-faturamento",
    category: "FINANCEIRO",
    elIcon: "el-icon-bank-card",
    description: "Contratos e OSs aptas para emissão de nota e faturamento",
    keywords: ["para faturar", "faturar", "contratos faturamento", "faturamento", "emitir nota", "financeiro"]
  },
  {
    name: "Notas Fiscais (NFS-e)",
    path: "/nota",
    category: "FINANCEIRO",
    elIcon: "el-icon-tickets",
    description: "Painel de emissão, consulta e cancelamento de NFS-e",
    keywords: ["nota", "notas", "nfse", "nota fiscal", "sefin", "tributos", "rps", "dps", "financeiro"]
  },
  {
    name: "Conferência Diária de Notas",
    path: "/conferencia-diaria-notas",
    category: "FINANCEIRO",
    elIcon: "el-icon-document-checked",
    description: "Auditoria diária de notas emitidas, autorizadas e rejeitadas",
    keywords: ["conferencia", "conferencia diaria", "auditoria", "notas", "nfse", "divergencias", "financeiro"]
  },
  {
    name: "Contas a Pagar (Notas de Entrada)",
    path: "/notas-entrada",
    category: "FINANCEIRO",
    elIcon: "el-icon-sell",
    description: "Despesas, contas a pagar e notas fiscais de fornecedor",
    keywords: ["contas a pagar", "pagar", "notas entrada", "fornecedor", "despesas", "financeiro"]
  },
  {
    name: "Fluxo de Caixa",
    path: "/caixa",
    category: "FINANCEIRO",
    elIcon: "el-icon-coin",
    description: "Livro caixa, entradas, saídas e conciliação bancária",
    keywords: ["caixa", "fluxo de caixa", "entradas", "saidas", "saldo", "banco", "financeiro"]
  },
  {
    name: "DRE (Demonstrativo de Resultado)",
    path: "/DRE",
    category: "FINANCEIRO",
    elIcon: "el-icon-pie-chart",
    description: "Demonstrativo financeiro de receitas, custos e despesas",
    keywords: ["dre", "resultado", "lucro", "faturamento", "despesas", "financeiro"]
  },
  {
    name: "Boletos Bancários",
    path: "/boleto",
    category: "FINANCEIRO",
    elIcon: "el-icon-document",
    description: "Geração, consulta e arquivos de remessa/retorno bancário",
    keywords: ["boleto", "boletos", "banco", "remessa", "retorno", "financeiro"]
  },
  {
    name: "Movimento de Estoque",
    path: "/movimento",
    category: "PCO",
    elIcon: "el-icon-data-line",
    description: "Entradas e saídas de produtos do estoque",
    keywords: ["movimento", "estoque", "produtos", "entrada", "saida"]
  },
  {
    name: "Centros de Custos",
    path: "/centro-custo",
    category: "FINANCEIRO",
    elIcon: "el-icon-office-building",
    description: "Estrutura de centros de custos e rateios",
    keywords: ["centro de custo", "centro de custos", "rateio", "financeiro"]
  },
  {
    name: "Plano de Contas",
    path: "/plano-conta",
    category: "FINANCEIRO",
    elIcon: "el-icon-notebook-2",
    description: "Plano de contas contábil e categorias de lançamento",
    keywords: ["plano de contas", "classificacao", "contabilidade", "financeiro"]
  },
  {
    name: "Formas de Pagamento",
    path: "/formas-pagamentos",
    category: "FINANCEIRO",
    elIcon: "el-icon-wallet",
    description: "Configuração de cartões, boletos, PIX e dinheiro",
    keywords: ["formas de pagamento", "forma de pagamento", "pix", "boleto", "cartao", "dinheiro"]
  },

  // DASHBOARDS E RELATÓRIOS
  {
    name: "Dashboard PCO",
    path: "/relatorio-pco",
    category: "DASHBOARDS",
    elIcon: "el-icon-data-analysis",
    description: "Visão analítica de execução, produtividade e atendimentos",
    keywords: ["dashboard pco", "relatorio pco", "indicadores", "graficos", "operacional"]
  },
  {
    name: "Relatório de Vendas",
    path: "/relatorio-vendas",
    category: "DASHBOARDS",
    elIcon: "el-icon-s-marketing",
    description: "Relatório comercial de contratos fechados e volume de vendas",
    keywords: ["relatorio vendas", "vendas", "comercial", "grafico vendas"]
  },
  {
    name: "Resultado NPS",
    path: "/resultado-nps",
    category: "DASHBOARDS",
    elIcon: "el-icon-trophy",
    description: "Pesquisa de satisfação, promotores, neutros e detratores",
    keywords: ["nps", "resultado nps", "satisfacao", "avaliacao", "net promoter score"]
  },
  {
    name: "Metas Operacionais",
    path: "/metas",
    category: "DASHBOARDS",
    elIcon: "el-icon-aim",
    description: "Acompanhamento de metas operacionais e financeiras",
    keywords: ["metas", "meta", "indicadores", "alvos"]
  },
  {
    name: "Relatório de Produtos (Estoque)",
    path: "/relatorio",
    category: "DASHBOARDS",
    elIcon: "el-icon-notebook-1",
    description: "Relatório de produtos e movimentação do estoque",
    keywords: ["relatorio", "produtos", "estoque", "consumo"]
  },

  // CONFIGURAÇÕES E CADASTROS
  {
    name: "Colaboradores e Usuários",
    path: "/colaborador",
    category: "CADASTROS",
    elIcon: "el-icon-s-custom",
    description: "Cadastro de técnicos, operadores e permissões de acesso",
    keywords: ["colaborador", "colaboradores", "usuarios", "tecnicos", "funcionarios", "permissoes"]
  },
  {
    name: "Produtos e Químicos",
    path: "/produtos",
    category: "CADASTROS",
    elIcon: "el-icon-box",
    description: "Estoque de defensivos, químicos e materiais de serviço",
    keywords: ["produto", "produtos", "quimicos", "defensivos", "estoque"]
  },
  {
    name: "Pragas Urbanas",
    path: "/pragas",
    category: "CADASTROS",
    elIcon: "el-icon-warning-outline",
    description: "Cadastro de pragas-alvo para ordens de serviço",
    keywords: ["pragas", "praga", "insetos", "roedores", "cupins"]
  },
  {
    name: "Régua de Disparos WATI",
    path: "/regua-disparos",
    category: "CONFIGURAÇÕES",
    elIcon: "el-icon-message-solid",
    description: "Regras automáticas de envio de WhatsApp (cobrança e pós-venda)",
    keywords: ["regua", "regua disparos", "mensagens", "wati", "whatsapp", "automacao"]
  },
  {
    name: "Parâmetros do Sistema",
    path: "/parametro",
    category: "CONFIGURAÇÕES",
    elIcon: "el-icon-s-operation",
    description: "Configurações gerais, templates e integrações do ERP",
    keywords: ["parametro", "parametros", "configuracao", "sistema", "geral"]
  },
  {
    name: "Empresa e Certificado Digital",
    path: "/empresa",
    category: "CONFIGURAÇÕES",
    elIcon: "el-icon-lock",
    description: "Dados fiscais da empresa e upload do Certificado A1",
    keywords: ["empresa", "certificado", "certificado digital", "a1", "cnpj", "fiscal"]
  },
  {
    name: "Releases e Atualizações",
    path: "/releases",
    category: "SOBRE O SISTEMA",
    elIcon: "el-icon-bell",
    description: "Histórico de versões e melhorias implantadas no sistema",
    keywords: ["releases", "versoes", "atualizacoes", "novidades", "changelog"]
  },
  {
    name: "Perfis de Acesso",
    path: "/perfil",
    category: "CONFIGURAÇÕES",
    elIcon: "el-icon-user-solid",
    description: "Perfis de usuário e as atividades (permissões) de cada um",
    keywords: ["perfil", "perfis", "permissoes", "acesso", "atividades"]
  }
];

// Atividade exigida por tela, igual aos bloqueios do menu lateral
// (VerticalNavMenu.menuItemsUpdated): 1 = Comercial, 4 = Financeiro,
// 7 = Serviços/PCO, 13 = Admin. Tela fora deste mapa não tem bloqueio no menu.
var ATIVIDADE_POR_PATH = {
  "/contrato": 1,
  "/kanban": 1,
  "/kanban-renovacao": 1,
  "/cliente": 1,
  "/prospeccao": 1,
  "/documentos": 1,
  "/lev-associar": 1,
  "/relatorio-vendas": 1,
  "/contas-receber": 4,
  "/cobranca": 4,
  "/contratos-faturamento": 4,
  "/nota": 4,
  "/conferencia-diaria-notas": 4,
  "/notas-entrada": 4,
  "/caixa": 4,
  "/DRE": 4,
  "/boleto": 4,
  "/agenda-os": 7,
  "/os-associar": 7,
  "/os-confirmacao": 7,
  "/retorno-os": 7,
  "/pos-venda": 7,
  "/servicos-endereco": 7,
  "/rota": 7,
  "/avaliacao-tecnica": 7,
  "/movimento": 7,
  "/relatorio-pco": 7,
  "/resultado-nps": 7,
  "/relatorio": 7,
  "/rota-config": 13,
  "/centro-custo": 13,
  "/plano-conta": 13,
  "/formas-pagamentos": 13,
  "/metas": 13,
  "/colaborador": 13,
  "/produtos": 13,
  "/pragas": 13,
  "/regua-disparos": 13,
  "/parametro": 13,
  "/empresa": 13,
  "/releases": 13,
  "/perfil": 13
};

// Indica se o perfil (lista de atividades do usuário) pode ver a tela.
// Sem lista de atividades, só passam as telas sem bloqueio.
export function rotaPermitida(route, permissoes) {
  if (!route) return false;
  var atividade = ATIVIDADE_POR_PATH[route.path];
  if (atividade === undefined) return true;
  return Array.isArray(permissoes) && permissoes.indexOf(atividade) !== -1;
}

// Função utilitária para normalizar strings (remover acentos e minúsculas)
export function normalizeString(str) {
  if (!str) return "";
  return String(str)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

// Algoritmo de busca inteligente e ranqueamento
export function searchSystemRoutes(rawQuery, maxResults, permissoes) {
  var limit = maxResults || 8;
  var query = normalizeString(rawQuery);

  if (!query) {
    return [];
  }

  var terms = query.split(/\s+/).filter(function(t) { return t.length > 0; });

  var permitidas = SYSTEM_ROUTES.filter(function(route) {
    return rotaPermitida(route, permissoes);
  });

  var scoredRoutes = permitidas.map(function(route) {
    var score = 0;
    var normName = normalizeString(route.name);
    var normCategory = normalizeString(route.category);
    var normDesc = normalizeString(route.description);
    var normPath = normalizeString(route.path);
    var normKeywords = (route.keywords || []).map(normalizeString);

    // Bônus para correspondência exata do título
    if (normName === query) {
      score += 100;
    } else if (normName.indexOf(query) === 0) {
      score += 50; // Começa com o termo
    } else if (normName.indexOf(query) !== -1) {
      score += 30; // Contém o termo
    }

    // Correspondência em palavras-chave
    for (var i = 0; i < normKeywords.length; i++) {
      var kw = normKeywords[i];
      if (kw === query) {
        score += 40;
      } else if (kw.indexOf(query) === 0) {
        score += 25;
      } else if (kw.indexOf(query) !== -1) {
        score += 15;
      }
    }

    // Correspondência em categoria ou caminho
    if (normCategory.indexOf(query) !== -1) {
      score += 20;
    }
    if (normPath.indexOf(query) !== -1) {
      score += 15;
    }
    if (normDesc.indexOf(query) !== -1) {
      score += 10;
    }

    // Match para múltiplos termos (ex: "contrato servico")
    if (terms.length > 1) {
      var allMatch = true;
      var nameMatchCount = 0;
      for (var tIdx = 0; tIdx < terms.length; tIdx++) {
        var t = terms[tIdx];
        var foundInName = normName.indexOf(t) !== -1;
        if (foundInName) {
          nameMatchCount++;
        }
        var foundInKw = normKeywords.some(function(k) { return k.indexOf(t) !== -1; });
        var foundInCat = normCategory.indexOf(t) !== -1;
        var foundInDesc = normDesc.indexOf(t) !== -1;
        if (!foundInName && !foundInKw && !foundInCat && !foundInDesc) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) {
        score += 45;
        if (nameMatchCount === terms.length) {
          score += 60;
        }
      }
    }

    return {
      route: route,
      score: score
    };
  });

  return scoredRoutes
    .filter(function(item) { return item.score > 0; })
    .sort(function(a, b) { return b.score - a.score; })
    .slice(0, limit)
    .map(function(item) { return item.route; });
}

// Helpers para Context Saving (Histórico de telas acessadas via search no localStorage)
var STORAGE_KEY = "gspro_home_recent_searches";

function lerRecentes() {
  try {
    var raw = window.localStorage ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (!raw) return [];
    var list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

export function getRecentSearches(permissoes) {
  // O histórico fica no navegador: outro usuário na mesma máquina não pode
  // ver telas que o perfil dele não acessa.
  return lerRecentes().filter(function(item) {
    return rotaPermitida(item, permissoes);
  });
}

export function saveRecentSearch(routeItem) {
  if (!routeItem || !routeItem.path) return;
  try {
    if (!window.localStorage) return;
    var current = lerRecentes();
    // Remove se já existir para colocar no topo
    var filtered = current.filter(function(item) {
      return item.path !== routeItem.path || item.name !== routeItem.name;
    });
    filtered.unshift({
      name: routeItem.name,
      path: routeItem.path,
      category: routeItem.category,
      elIcon: routeItem.elIcon || "el-icon-document",
      description: routeItem.description,
      isRecent: true
    });
    // Limita aos 5 últimos acessos
    var trimmed = filtered.slice(0, 5);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch (e) {
    // Ignora falhas de localStorage
  }
}

export function getBrowsableRoutes(options) {
  var opts = options || {};
  var category = opts.category || "TODOS";
  var page = opts.page || 1;
  var pageSize = opts.pageSize || 10;

  var filtered = SYSTEM_ROUTES.filter(function(r) {
    return rotaPermitida(r, opts.permissoes);
  });
  if (category && category !== "TODOS") {
    filtered = filtered.filter(function(r) {
      return r.category === category;
    });
  }

  var start = (page - 1) * pageSize;
  var end = page * pageSize;
  var items = filtered.slice(start, end);

  return {
    items: items,
    page: page,
    pageSize: pageSize,
    total: filtered.length,
    hasMore: end < filtered.length
  };
}

export function getAllCategories() {
  return [
    { id: "TODOS", name: "Todos", icon: "el-icon-menu" },
    { id: "COMERCIAL", name: "Comercial", icon: "el-icon-document-copy" },
    { id: "PCO", name: "Operações & PCO", icon: "el-icon-setting" },
    { id: "FINANCEIRO", name: "Financeiro", icon: "el-icon-money" },
    { id: "DASHBOARDS", name: "Dashboards", icon: "el-icon-pie-chart" },
    { id: "CONFIGURAÇÕES", name: "Cadastros & Config", icon: "el-icon-set-up" }
  ];
}

